import AppContext from 'App/AppContext';
import { copilotPanelResultBus } from 'models/copilot/copilotPanelResultBus';
import { useContext, useEffect, useRef } from 'react';

/**
 * Reloads a list scene after the user approved a staged mutation in the Copilot panel. A plain answer
 * changes no data, so only an approval reloads.
 */
export const useCopilotApprovalReload = (reload: () => void | Promise<void>): void => {
  const appContext = useContext(AppContext);
  const reloadRef = useRef(reload);
  reloadRef.current = reload;

  useEffect(() => {
    const subscription = copilotPanelResultBus.subscribeGeneralCompletion(
      (_context, _entityType, _entityId, afterApproval) => {
        if (!afterApproval) return;

        Promise.resolve()
          .then(() => reloadRef.current())
          .catch((err) => appContext.setError(err));
      },
    );

    return () => subscription.dispose();
  }, [appContext]);
};
